import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-number-of-files',
    templateUrl: './number-of-files.component.html',
    styleUrls: ['./number-of-files.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberOfFilesComponent {
    @Input() numberOfFiles?: number;
}
